import { useEffect } from 'react';

export const useNavigationGuard = (hasUnsavedChanges, message = 'You have unsaved changes. Are you sure you want to leave?') => {
  // Handle ALL navigation attempts (refresh, close, back/forward)
  useEffect(() => {
    if (!hasUnsavedChanges) {
      return;
    }

    // Handle browser-level navigation (refresh, close, back/forward)
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    // Handle browser back/forward buttons via popstate
    const handlePopState = (event) => {
      const shouldLeave = window.confirm(message);
      if (!shouldLeave) {
        // Prevent navigation by pushing the current state back
        window.history.pushState(null, '', window.location.href);
      }
    };

    // Push initial state to enable interception
    window.history.pushState(null, '', window.location.href);
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [hasUnsavedChanges, message]);

  return { hasUnsavedChanges };
};
